import { useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

const MobileNav = () => {
  const location = useLocation();
  const history = useHistory();
  const cart = useSelector((state) => state.cart);
  const cartItems = cart ? cart.cartItems : [];

  const path = location.pathname;

  const getActiveTab = (currentPath) => {
    if (currentPath.includes("/cart")) return "cart";
    if (currentPath.includes("/profile") || currentPath.includes("/order")) return "order";
    if (currentPath.includes("/best-deal")) return "bestdeal";
    if (currentPath === "/") return "home";
    return localStorage.getItem("activeNavTab") || "home";
  };

  const [activeTab, setActiveTab] = useState(
    localStorage.getItem("activeNavTab") || getActiveTab(path)
  );

  const handleNav = (tab, route) => {
    localStorage.setItem("activeNavTab", tab);
    setActiveTab(tab);
    history.push(route);
  };

  return (
    <>
      <div className="mobile-nav-spacer"></div>
      <div className="bottom-navbar-section mobile-nav-custom">
        <div className="bottom-navbar custom-bottom-nav">

          {/* Home */}
          <div
            className={`nav-item ${activeTab === "home" ? "active" : ""}`}
            onClick={() => handleNav("home", "/")}
          >
            <div className="icon-container">
              <i className="fas fa-home"></i>
            </div>
            <span className="nav-text">Home</span>
          </div>

          {/* Best Deal */}
          <div
            className={`nav-item ${activeTab === "bestdeal" ? "active" : ""}`}
            onClick={() => handleNav("bestdeal", "/best-deal")}
          >
            <div className="icon-container">
              <i className="fas fa-tags"></i>
            </div>
            <span className="nav-text">Best Deal</span>
          </div>

          {/* Order */}
          <div
            className={`nav-item ${activeTab === "order" ? "active" : ""}`}
            onClick={() => handleNav("order", "/profile")}
          >
            <div className="icon-container">
              <i className="fas fa-file-invoice"></i>
            </div>
            <span className="nav-text">Order</span>
          </div>

          {/* Cart */}
          <div
            className={`nav-item ${activeTab === "cart" ? "active" : ""}`}
            onClick={() => handleNav("cart", "/cart")}
          >
            <div className="icon-container" style={{ position: "relative" }}>
              <i className="fas fa-shopping-cart"></i>
              {cartItems && cartItems.length > 0 && (
                <span className="cart-badge">{cartItems.length}</span>
              )}
            </div>
            <span className="nav-text">Cart</span>
          </div>

          
        {/* Profile */}
<div
  className={`nav-item ${activeTab === "profile" ? "active" : ""}`}
  onClick={() => handleNav("profile", "/profile")}
>
  <div className="icon-container">
    <i className="fas fa-user"></i>
  </div>
  <span className="nav-text">Profile</span>
</div>

        </div>
      </div>
    </>
  );
};

export default MobileNav;
